(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["angler-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('asc-water-slideshow')) {
  customElements.define('asc-water-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.asc-water-slide')];
      this.choices = [...this.querySelectorAll('[data-water]')];
      this.toggle = this.querySelector('.asc-water-toggle');
      this.status = this.querySelector('.asc-water-status');
      if (this.slides.length < 2 || !this.toggle) return;
      this.index = 0;
      this.request = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovering = false;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.choices.forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(Number(button.dataset.water), true);
        this.sync();
      }, options));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('pointerenter', e => {
        if (e.pointerType === 'mouse') { this.hovering = true; this.sync(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovering = false; this.sync(); }, options);
      this.addEventListener('focusin', e => {
        if (!this.contains(e.relatedTarget)) { this.paused = true; this.sync(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.sync();
      }, options);
      this.addEventListener('touchstart', e => {
        this.touch = e.touches.length === 1 && !e.target.closest('a,button') ? { x:e.touches[0].clientX, y:e.touches[0].clientY } : null;
      }, { ...options, passive:true });
      this.addEventListener('touchend', e => {
        if (!this.touch || !e.changedTouches.length) return;
        const dx = e.changedTouches[0].clientX - this.touch.x;
        const dy = e.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.paused = true;
          this.show(this.index + (dx < 0 ? 1 : -1), true);
          this.sync();
        }
      }, { ...options, passive:true });
      this.addEventListener('touchcancel', () => { this.touch = null; }, options);
      this.setAttribute('data-ready', '');
      this.sync();
    }
    async show(next, announce = false) {
      const index = (next + this.slides.length) % this.slides.length;
      const ticket = ++this.request;
      const image = this.slides[index].querySelector('img');
      if (!image) return;
      try { await image.decode(); } catch { return; }
      if (!this.isConnected || ticket !== this.request) return;
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        this.choices[i].setAttribute('aria-pressed', String(i === index));
      });
      if (announce) this.status.textContent = this.slides[index].getAttribute('aria-label') + ' image';
    }
    sync() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? 'Play ▶' : 'Pause ❚❚';
      this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      if (!this.paused && !this.hovering && !document.hidden) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.events?.abort();
      this.request++;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
